import { render, staticRenderFns } from "./RecoveryWiki.vue?vue&type=template&id=68bf0f2f&scoped=true&"
import script from "./RecoveryWiki.vue?vue&type=script&lang=ts&"
export * from "./RecoveryWiki.vue?vue&type=script&lang=ts&"
import style0 from "./RecoveryWiki.vue?vue&type=style&index=0&id=68bf0f2f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bf0f2f",
  null
  
)

export default component.exports